<template>
  <section>
    <div class="py-5">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-xl-5">
            <div class="conference-title">
              <h1>Managing for Social Impact</h1>
              <h2 class="my-3">
                Sustainable and Ethical Leadership in the times of turbulence
              </h2>
            </div>
            <div>
              <p>
                Join us at the forthcoming conference on “Managing for Social
                Impact” April 12, 2024, jointly organized by The Hang Seng
                University of Hong Kong and MLA Academy, where we will explore
                the crucial question: “What is the purpose of business?” In a
                world characterized by volatility, uncertainty, complexity, and
                ambiguity (VUCA), it is essential to challenge the assumptions
                that underpin our existing paradigms and theories.
              </p>
              <p>
                Peter Drucker, the father of modern management, asserts that the
                purpose of business is to create customer by doing the right
                thing. At the conference, we will delve into the concept and
                practices of human-centered management that integrate wealth
                creation, human fulfilments and social concerns, to address
                pressing issues such as climate crisis, social inequality,
                ethical governance (ESG) and sustainability concerns.
              </p>
              <p>
                In these turbulent times, the future relies on visionary
                leadership and the unwavering commitment, convictions, and
                integrity of individuals. Join us at the Conference to meet
                management gurus and leaders, gain insights, exchange ideas and
                shape the role of future management and leadership in society.
                Together, we can create a more sustainable and inclusive future.
              </p>
              <CtaButton
                class="mt-5"
                target="_blank"
                href="https://hsuhk.sharepoint.com/:b:/t/o365_CMLA-Intranet/EQcROPOy0pZInrsLvkAbRqcBtuXf6tLEzKeTmBk0Q6De9Q?e=nXpPie"
              >
                Read Newsletter
              </CtaButton>
            </div>
            <div class="conference-title my-5">
              <iframe
                src="https://drive.google.com/file/d/1T1NKoFmLCPsIe1rryUQlK1PfqHiLb9Od/preview"
                allow="autoplay"
                style="width: 100%; aspect-ratio: 16/9; border: none"
              ></iframe>
            </div>
          </div>
          <div class="col-sm-12 col-xl-2"></div>
          <div class="col-sm-12 col-xl-5">
            <a class="anchorLinkBtn" href="#conference-about">
              About the Conference
            </a>
            <a class="anchorLinkBtn" href="#conference-speaker">
              Speakers and Chairs
            </a>
            <a class="anchorLinkBtn" href="#conference-agenda"> Program </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
section {
  padding: 100px 0;
  font-size: 18px;
  font-weight: 400;
  background-color: #f6f6f6;
  --bs-body-bg: #f6f6f6;
}

.conference-title {
  h1 {
    color: #3948ce;
    font-weight: 800;
    font-size: 2.5em;
  }
  h2 {
    font-weight: 800;
    font-size: 1.5em;
    line-height: 1.25em;
  }
}

.anchorLinkBtn {
  border-radius: 100px;
  border: 10px solid rgba(165, 165, 165, 0.25);
  background-color: white;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  max-width: 437px;
  display: block;
  margin: 30px auto;
  padding: 24px;
}
</style>
